import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05f69c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backtest-period" }
const _hoisted_2 = { class: "period-options" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 自定义 ")
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presetPeriods, (opt) => {
        return (_openBlock(), _createElementBlock("div", {
          key: opt.code,
          class: _normalizeClass(["period-option", { selected: _ctx.selectedCode === opt.code }]),
          style: _normalizeStyle(_ctx.selectedCode === opt.code ? {} : _ctx.unselectedStyle),
          onClick: ($event: any) => (_ctx.selectPeriod(opt.code))
        }, [
          _createTextVNode(_toDisplayString(opt.name) + " ", 1),
          (_ctx.selectedCode === opt.code)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "close-btn",
                onClick: _withModifiers(($event: any) => (_ctx.selectPeriod(opt.code)), ["stop"])
              }, [
                _createElementVNode("img", {
                  src: _ctx.closeIcon,
                  alt: "关闭"
                }, null, 8, _hoisted_5)
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ], 14, _hoisted_3))
      }), 128)),
      _createElementVNode("div", {
        class: _normalizeClass(["period-option custom-period-option", { selected: _ctx.selectedCode === 'custom' }]),
        style: _normalizeStyle(_ctx.selectedCode === 'custom' ? {} : _ctx.unselectedStyle),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedCode !== 'custom' && _ctx.selectPeriod('custom')))
      }, [
        _hoisted_6,
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_component_a_range_picker, {
            value: _ctx.customDateRange,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customDateRange) = $event)),
            "disabled-date": _ctx.disabledCustomDate,
            format: "YYYY-MM-DD",
            class: "custom-range-picker",
            onChange: _ctx.onCustomDateChange
          }, null, 8, ["value", "disabled-date", "onChange"])
        ]),
        (_ctx.selectedCode === 'custom')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "close-btn",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectPeriod('custom')), ["stop"]))
            }, [
              _createElementVNode("img", {
                src: _ctx.closeIcon,
                alt: "关闭"
              }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ], 6)
    ])
  ]))
}